import {
  activityBaseApi,
  ActivityTags,
} from "activity/redux/api/activityBaseApi";
import { IAreasTransfers } from "commonFnBcode/types/dmc.types";
import { IJSONResponse } from "components/afterLogin/dashboard/flightApis/AirlineDiscountMarkup/types";

export const queryGenerator = (query) =>
  `${Object.keys(query)
    .map(
      (k) => `${k}=${Array.isArray(query[k]) ? query[k].join(",") : query[k]}`
    )
    .join("&")}`;

export const areasTransferApi = activityBaseApi.injectEndpoints({
  endpoints: (build) => ({
    //=============================== get all areas =====================================
    fetchAreasTransfer: build.query<
      IJSONResponse<IAreasTransfers[]>,
      {
        regex?: string;
        cities?: number[];
        fromDate?: string;
        toDate?: string;
        cityId?: number | undefined;
        inrRate?: string;
        totalPax?: number;
        cartId?: string | number;
      }
    >({
      query: (query) => `areas/getTransfers?${queryGenerator(query)}`,
      providesTags: [ActivityTags.getAreasTransfers],
    }),

    //=============================== delete area =====================================
    deleteAreaTransfer: build.mutation<IJSONResponse, number>({
      query: (id) => ({
        url: `areas/deleteTransfers/${id}`,
        method: "POST",
      }),
      invalidatesTags: [ActivityTags.getAreasTransfers],
    }),

    //=============================== add area =====================================
    addAreaTransfer: build.mutation<IJSONResponse, any>({
      query: (body) => ({
        url: "areas/createTransfers",
        method: "POST",
        body,
      }),
      invalidatesTags: [ActivityTags.getAreasTransfers],
    }),
  }),
  overrideExisting: false,
});
